import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import global_en from "./translations/en/global.json";
import global_pl from "./translations/pl/global.json";
import global_ua from "./translations/ua/global.json";
import global_de from "./translations/de/global.json";

import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { I18nextProvider } from 'react-i18next';
import { AuthProvider } from './context/AuthContext';
import { ToastContainer } from 'react-toastify';

i18next
  .use(LanguageDetector)
  .init({
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "language",
      checkWhitelist: true,
      caches: ["localStorage"],
    },
    fallbackLng: "en",
    whitelist: ["en", "pl", "ua", "de"],
    resources: {
      en: { global: global_en },
      pl: { global: global_pl },
      ua: { global: global_ua },
      de: { global: global_de },
    },
    interpolation: { escapeValue: false },
  }, () => {
    const detected = i18next.language; 
    let finalLang = detected;

    if (detected === "uk") {
      finalLang = "ua";
    } 
    else if (!["en", "pl", "ua", "de"].includes(detected)) {
      finalLang = "en";
    }

    if (finalLang !== detected) {
      i18next.changeLanguage(finalLang);
    }
  });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18next}>
      <AuthProvider>
        <App />
        <ToastContainer />
      </AuthProvider>
    </I18nextProvider>
  </React.StrictMode>
);

reportWebVitals();
